import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import teksturtitle from './assets/home/teksturtitle.png'

import Footer from './footer'
import { SupportForm } from './SupportForm'

function TekstUrSupport() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="tekstur" style={{ flex: 1, marginTop: '1vw' }}>
          <a href="/tekstur">
            <img className="teksturtitle2" src={teksturtitle} />
          </a>
          <div className="rankytanksubtitleprivacy" style={{}}>
            Support
          </div>

          <SupportForm lang="dk" appType="tekstur" />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default TekstUrSupport
